import { render, staticRenderFns } from "./HistoryArchive.vue?vue&type=template&id=009dcbc9&scoped=true"
import script from "./HistoryArchive.vue?vue&type=script&setup=true&lang=ts"
export * from "./HistoryArchive.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./HistoryArchive.vue?vue&type=style&index=0&id=009dcbc9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009dcbc9",
  null
  
)

export default component.exports